import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { LIBRARY_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

const SLICE = "ReleaseHighlights";

const isReleaseHighlightsThunk = (action: any) => action.type.startsWith(`${SLICE}/`); // This is to check fullfilled and rejected cases only for ReleaseHighlights Slice.

const initialState: any = {
  loadingCount: 0,
  isReleaseHighlightOpen: false,
  newInBoostResources: [],
  isPostBoostBuzzClick: true,
  isBuzzVisible: false,
  skipUseEffect: false,
  targetedInncode: []
};

export const fetchBuzzCards = createAsyncThunk(`${SLICE}/fetchBuzzCards`, (data: any, thunkApi) => {
  return apiRequest(LIBRARY_SERVICE_METHOD.postCards, data.payload, thunkApi, ["buzz"]);
});

export const markBuzzAsViewed = createAsyncThunk(`${SLICE}/markBuzzAsViewed`, (data?: any, thunkApi?: any) => {
  return apiRequest(USER_SERVICES_METHOD.patchAssociatesMetadata, {}, thunkApi, [], {
    update_type: data?.update_type
  });
});

export const ReleaseHighlights = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        newInBoostResources: state.newInBoostResources
      };
    },
    setReleaseHighlightDialog: (state, action) => {
      state.isReleaseHighlightOpen = action?.payload;
    },
    setIsPostBoostBuzzClick: (state, action) => {
      state.isPostBoostBuzzClick = action.payload;
    },
    setShowBuzzSection: (state, action) => {
      state.isBuzzVisible = action.payload;
    },
    setSkipUseEffect: (state, action) => {
      state.skipUseEffect = action.payload;
    },
    settargetdInncodes: (state, action) => {
      state.targetedInncode = action.payload;
    },
    setReleaseNote: (state, action) => {
      const { inncode, payload } = action.payload;
      state[inncode] = {
        ...state[inncode],
        releaseNotes: payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuzzCards.fulfilled, (state, action) => {
        state[action.meta.arg.hltId] = {
          releaseNotes:
            action.meta?.arg?.source === "api"
              ? action.payload.cards.filter((item: any) => item.latest)
              : action.payload.cards,
          showBuzzSection: !!action.payload.cards.length,
          allCards: action.payload.cards
        };
      })
      .addMatcher(
        (action) => isPending(action) && isReleaseHighlightsThunk(action),
        (state, action) => {
          if (
            // turn on loader if api is not paginated or it is for 1st page
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount += 1;
          }
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isReleaseHighlightsThunk(action),
        (state, action) => {
          if (
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount -= 1;
          }
        }
      );
  }
});

export const {
  reset,
  setReleaseHighlightDialog,
  setIsPostBoostBuzzClick,
  setShowBuzzSection,
  setSkipUseEffect,
  settargetdInncodes,
  setReleaseNote
} = ReleaseHighlights.actions;

export default ReleaseHighlights.reducer;
